import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { outbox } from '../lib/outbox';
import type { MessageDto } from '../api/types';

export default function OutboxMessages({ ownerId, chatId, roomId, messages }: {
  ownerId?: string; chatId: string; roomId: string | null; messages: MessageDto[];
}) {
  const { t } = useTranslation('chatView');
  const [, update] = useState(0);
  const [actionError, setActionError] = useState(false);
  useEffect(() => outbox.subscribe(() => update(value => value + 1)), []);
  if (!ownerId) return null;
  const confirmed = new Set(messages.filter(message => message.senderId === ownerId).map(message => message.clientMsgId));
  const items = outbox.snapshot(ownerId).filter(item => item.chatId === chatId
    && (item.body.roomId ?? null) === roomId && !confirmed.has(item.body.clientMsgId));
  const action = (operation: Promise<void>) => {
    setActionError(false);
    void operation.catch(() => setActionError(true));
  };
  return <>
    {(actionError || outbox.hasStorageError()) && <div className="error" role="alert">{t('outbox.storageError')}</div>}
    {items.map(item => {
      const data = item.body.payload.data as { text?: string; media?: { fileName?: string }[] } | undefined;
      const sending = outbox.isSending(item.body.clientMsgId);
      return <div key={item.body.clientMsgId} className="msg me pending-upload-msg">
        <div style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{data?.text}</div>
        {data?.media?.map((media, index) => <div key={index}>{media.fileName || t('upload.file')}</div>)}
        <span role="status">{t(item.failed ? 'outbox.failed' : sending ? 'upload.sending' : 'outbox.waiting')}</span>
        <div className="pending-upload-msg-row">
          <button type="button" className="link-btn" disabled={sending} onClick={() => action(outbox.retry(ownerId, item.body.clientMsgId))}>{t('upload.retry')}</button>
          <button type="button" className="link-btn" disabled={sending} onClick={() => action(outbox.cancel(ownerId, item.body.clientMsgId))}>{t('upload.cancel')}</button>
        </div>
      </div>;
    })}
  </>;
}
